module.exports = __webpack_public_path__ + "img/sdg_es_(7).ad5767ed.png";